export const enum FieldName {
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  Phone = 'PHONE',
  EmailAddress = 'EMAIL_ADDRESS',
  OrderId = 'ORDER_ID',
  /** The order number displayed to user and sent in mutation.
   * It's equal to orderId for H24 orders and oms.orderId for marketplace orders.
   * */
  OrderNumber = 'ORDER_NUMBER',
  ProductName = 'PRODUCT_NAME',
  Comment = 'COMMENT',
  Images = 'IMAGES',
  Channel = 'CHANNEL',
}

export const enum FieldType {
  Text = 'Text',
  Textarea = 'Textarea',
}

export const enum StorageKey {
  Reason = 'contactForm_reason',
  Comment = 'contactForm_comment',
  Images = 'contactForm_images',
}

export const enum RootReason {
  ProductAdviceShowroomOutlet = 'product_advice_showroom_outlet',
  MyAccountHowToOrder = 'my_account_how_to_order',
  DeliveryCancellation = 'delivery_cancellation',
  PaymentVoucher = 'payment_voucher',
  ClaimReturn = 'claim_return',
  OtherRequests = 'other_requests',
  B2B = 'b2b',
}

export const enum VisibilitySliceType {
  CallbackSolution = 'callback_solution',
}
